module.exports = __webpack_public_path__ + "staticcomp/img/top.44660e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/5/top.jpg
// module id = gCUd
// module chunks = 39